import { Action } from '@ngrx/store';
import { TableFilter } from '../models/table-filter.model';

export enum ActionTypes {
    ADD_FILTER          = '[Financial Documents Table Filters] Add Filter',
    ADD_DATE_FILTER     = '[Financial Documents Table Filters] Add Date Filter',
    ADD_FILTERS         = '[Financial Documents Table Filters] Add Filters',
    REMOVE_FILTER       = '[Financial Documents Table Filters] Remove Filter',
    REMOVE_DATE_FILTER  = '[Financial Documents Table Filters] Remove Date Filter',
    REMOVE_FILTERS      = '[Financial Documents Table Filters] Remove Filters',
    CLEAR_FILTERS       = '[Financial Documents Table Filters] Clear Filters',
}


export class AddFilter implements Action {
    readonly type: string = ActionTypes.ADD_FILTER;

    constructor(public payload: TableFilter) {}
}

export class AddDateFilter implements Action {
    readonly type: string = ActionTypes.ADD_DATE_FILTER;

    constructor(public payload: TableFilter) {}
}

export class AddFilters implements Action {
    readonly type: string = ActionTypes.ADD_FILTERS;

    constructor(public payload: TableFilter[]) {}
}

export class RemoveFilter implements Action {
    readonly type: string = ActionTypes.REMOVE_FILTER;

    constructor(public payload: TableFilter) {}
}

export class RemoveDateFilter implements Action {
    readonly type: string = ActionTypes.REMOVE_DATE_FILTER;

    constructor(public payload: TableFilter) {}
}

export class RemoveFilters implements Action {
    readonly type: string = ActionTypes.REMOVE_FILTERS;

    constructor(public payload: string) {}
}

export class ClearFilters implements Action {
    readonly type: string = ActionTypes.CLEAR_FILTERS;

    constructor(public payload?: any) {}
}


export type Actions =
    | AddFilter
    | AddDateFilter
    | AddFilters
    | RemoveFilter
    | RemoveDateFilter
    | RemoveFilters
    | ClearFilters;
